import { connect } from 'react-redux';
import Sidebar from './Sidebar';
import {
  fetchMyAuthorizations,
  fetchUniqueSelectors,
  getCurrentSelection,
  getSelectorsData,
  setMyAuthorizationPending,
  setSelectorsList,
} from '../store/myAuthorizationsSlice';
import { setFilters } from '../../filters/store/filtersSlice';
import { setMobileDrawerOpen } from '../../mobile-drawer/store/mobileDrawerSlice';

const mapState = state => ({
  currentSelection: getCurrentSelection(state),
  selectedIndex: state.loadingManagement.filters.selectedIndex,
  selectorsList: getSelectorsData(state),
  selectorsListPending: state.loadingManagement.myAuthorizations.selectorsListPending,
  twoPartyExchangeError: state.loadingManagement.myAuthorizations.twoPartyExchangeError,
});

const mapDispatchToProps = {
  fetchMyAuthorizations,
  fetchUniqueSelectors,
  setFilters,
  setMobileDrawerOpen,
  setMyAuthorizationPending,
  setSelectorsList,
};

export default connect(mapState, mapDispatchToProps)(Sidebar);
